import {IFieldMeta, EFieldType} from 'entities/metadata';

export enum ERequestHeaderStyle {
    CUSTOM_TITLE = 'custom-title',
    CUSTOM_CARD_TITLE = 'custom-card-title'
}
export enum ERequestFormFormKey {
    REQUESTS = 'requests',
    REQUEST_RESPONSE = 'requestResponse',
    REQUEST_PROLONGATION = 'prolongationRequest',
    RESPONSE_PROLONGATION = 'prolongationResponse',
    REQUEST_ADDITIONAL_PLACEMENT = 'requestAdditionalPlacement',
    REQUEST_REJECTION = 'requestRejection'
}
export enum ERequestTypeCode {
    REQUEST = 'request',
    MESSAGE = 'message',
    REQUEST_DIT = 'requestDit',
    RESPONSE = 'response',
    COMMENT_REQUEST = 'comment_request',
    REQUEST_PUD = 'requestPUD',
}

export const RequestFormTitles = {
    [ERequestFormFormKey.REQUESTS]: 'Информация по запросу',
    [ERequestFormFormKey.REQUEST_RESPONSE]: 'Ответ на запрос ',
    [ERequestFormFormKey.REQUEST_PROLONGATION]: 'Запрос на продление',
    [ERequestFormFormKey.RESPONSE_PROLONGATION]: 'Решение о продлении ФНС',
    [ERequestFormFormKey.REQUEST_REJECTION]: 'Отказ в доразмещении',
} as const;

export enum ERequestStatus{
    IN_PREPARATION_RESPONSE = 'IN_PREPARATION_RESPONSE',
    DRAFT='DRAFT',
}
export const REQUEST_FIELD_CONTENT: IFieldMeta = {
    key: 'content',
    label: 'Комментарий',
    type: EFieldType.STRING,
    referenceUrl: '/lookupValue/REQUEST_TYPE',
    isRequired: true,
    path: {
        label: 'description',
        value: 'id',
    },
};

export const REQUEST_FIELD_FILES: IFieldMeta = {
    key: 'files',
    label: 'Файлы',
    type: EFieldType.FILE_LIST_WITH_SIGNS,
    width: 920,
};

export const requestMainFields: IFieldMeta[] = [
    REQUEST_FIELD_CONTENT,
    REQUEST_FIELD_FILES,
];
